import About from "../../components/about/about";
import BlogSection from "../../components/blog/blogsection";
import Features from "../../components/features/features";
import HeroSection from "../../components/herosection/hero";
import SectionLast from "../../components/sectionlast/SectionLast";
import Media from "../../components/tokens/tokens";

function Home() {

    return (
        <div>
            <HeroSection />
            <Features />
            <About />
            <Media />
            <BlogSection />
            <SectionLast heading={'Ready for blockchain visibility?'} />
        </div>
    );
}

export default Home;